
document.addEventListener('DOMContentLoaded', function () {
  initCollectionSliders();
});

document.addEventListener('shopify:section:load', function () {
  initCollectionSliders();
});

function initCollectionSliders() {
  const grids = document.querySelectorAll(
    '.main-collection-grid .product-grid'
  );

  grids.forEach(function (grid) {
    if (grid.dataset.collectionSlider === 'true') return;

    grid.dataset.collectionSlider = 'true';

    const items = grid.querySelectorAll('.product-grid__item');

    if (items.length < 2) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'collection-slider-wrapper';

    grid.parentNode.insertBefore(wrapper, grid);
    wrapper.appendChild(grid);

    const prevButton = document.createElement('button');
    prevButton.className =
      'collection-slider-button collection-slider-prev';
    prevButton.type = 'button';
    prevButton.setAttribute('aria-label', 'Produits précédents');
    prevButton.innerHTML = '&#10094;';

    const nextButton = document.createElement('button');
    nextButton.className =
      'collection-slider-button collection-slider-next';
    nextButton.type = 'button';
    nextButton.setAttribute('aria-label', 'Produits suivants');
    nextButton.innerHTML = '&#10095;';

    wrapper.appendChild(prevButton);
    wrapper.appendChild(nextButton);

    function getScrollAmount() {
      const item = grid.querySelector('.product-grid__item');

      if (!item) return 300;

      const gap =
        parseInt(window.getComputedStyle(grid).gap) || 20;

      return item.offsetWidth + gap;
    }

    prevButton.addEventListener('click', function () {
      grid.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    nextButton.addEventListener('click', function () {
      grid.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });

    let autoSlide;

    function startAutoSlide() {
      clearInterval(autoSlide);

      autoSlide = setInterval(function () {
        const maxScroll =
          grid.scrollWidth - grid.clientWidth;

        if (grid.scrollLeft >= maxScroll - 10) {
          grid.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        } else {
          grid.scrollBy({
            left: getScrollAmount(),
            behavior: 'smooth'
          });
        }
      }, 3500);
    }

    function stopAutoSlide() {
      clearInterval(autoSlide);
    }

    wrapper.addEventListener('mouseenter', stopAutoSlide);
    wrapper.addEventListener('mouseleave', startAutoSlide);

    wrapper.addEventListener(
      'touchstart',
      stopAutoSlide,
      { passive: true }
    );

    wrapper.addEventListener(
      'touchend',
      function () {
        setTimeout(startAutoSlide, 1500);
      },
      { passive: true }
    );

    startAutoSlide();
  });
}